module.exports = __webpack_public_path__ + "static/media/brief.46916bfc.svg";